<template>
  <div>
    <el-button @click="dialogVisibles = true">查询用户抢购额度</el-button>
    <el-dialog
      :visible.sync="dialogVisibles"
      title="查询用户额度"
      width="1000px"
      @close="closeDialog"
    >
      <el-form label-width="100px">
        <el-form-item label="关键词：">
          <el-input v-model="keywords"></el-input>
          <el-button type="primary" @click="handleSave()">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="projectList">
        <el-table-column prop="origin" label="额度类型">
          <template slot-scope="scope">
            <span v-if="scope.row.origin == 1">邀请额度</span>
            <span v-else-if="scope.row.origin == 2">USDT额度</span>
            <span v-else-if="scope.row.origin == 3">FBS额度</span>
          </template>
        </el-table-column>
        <el-table-column prop="userId" label="用户ID"></el-table-column>
        <el-table-column label="刷新时间">
          <template slot-scope="scope">
            <span>{{ scope.row.updateTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="额度"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Editor from 'components/editor';

export default {
  name: 'CreateContent',
  data() {
    return {
      dialogVisibles: false,
      projectList: [],
      keywords: ''
    };
  },
  components: {
    Editor
  },
  computed: {},
  methods: {
    ...mapActions('foundationProject', ['searchAmount']),
    closeDialog() {
      this.$refs['baseForm'].resetFields();
    },
    handleSave() {
      if (!this.keywords) {
        this.$message({
          message: '关键词不能为空',
          type: 'error'
        });
        return;
      } else {
        this.searchAmount({ keywords: this.keywords }).then(res => {
          this.projectList = res.data;
        });
      }
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.el-button {
  margin-left: 15px;
}
</style>
